import { Component, ElementRef, LOCALE_ID, OnInit, ViewChild, inject, signal } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ViewChildren, QueryList } from '@angular/core';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';
import { Chart, registerables } from 'chart.js';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from "rxjs";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { VisibilityManagerComponent } from 'components/visibility-manager/visibility-manager.component';
import { CalendarioComponent } from 'components/calendario/calendario.component';
import { FiltroPadraoComponent } from 'components/filtro-padrao/filtro-padrao.component';
import { FiltroPadrao } from "src/app/shared/models/filtro-padrao/filtroPadrao";
import { ListarChamados } from "src/app/shared/models/chamados/listar-chamados";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { Consolidado } from "src/app/shared/models/relatorio/Consolidado";
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { DashboardAtividadePsicologo } from 'src/app/shared/models/chamados/listar-atividades-psicologos';
import { RelatorioPOCResumo } from 'src/app/shared/models/relatorio/RelatorioPOCResumo';
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";

declare const window: any;
declare let html2canvas: any;


@Component({
  selector: 'relatorio-pec',
  standalone: true,
  imports:[angularCommonImports, convivaCommonImports, libsCommonImports, NgChartsModule, NgxSpinnerModule, VisibilityManagerComponent, CalendarioComponent, FiltroPadraoComponent],
  templateUrl: './relatorio-pec.component.html',
  styleUrl: './relatorio-pec.component.scss'
})

export class RelatorioPecComponent implements OnInit {
  @ViewChildren(BaseChartDirective) charts!: QueryList<BaseChartDirective>;
  @ViewChild(FiltroPadraoComponent) filtroPadraoComponent: FiltroPadraoComponent;
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;

  // Servicios inyectados
  public spinnerService = inject(NgxSpinnerService);
  public toastr = inject(ToastrService);
  public chamadoService = inject(ChamadoService);
  public convivaErrors = inject(ConvivaErrorHandlingService);
  public psicologoService = inject(PsicologoService);
  public authService = inject(AuthService);
  public locale = inject(LOCALE_ID);
  public userLogado: UserLoginSed | null = null;
  public atribuicoesLogin: AtribuicaoLoginSed = {} as AtribuicaoLoginSed;
  public filtros: FiltroPadrao;
  public submitted = false;
  public mesCalendario: number;
  public anoCalendario: number;
  public lstAcoes: DashboardAtividadePsicologo[] = [];
  public qtyAcoes: number = 0;
  public qtyAcoesAcolhimento: number = 0;
  public qtyAcoesPrevencao: number = 0;
  public porcAcoesAcolhimento: number = 0;
  public porcAcoesPrevencao: number = 0;
  private pesquisaEmAndamento = false;
  private pesquisaSequencia = 0;
  public pesquisaRealizada = false;
  private get DataAtual (){return new Date()}
  public minDate:string = '2021-01-01' ;
  public maxDate:string = `${this.DataAtual.getFullYear()}-12-30` ;
  public infoPeriodo: any = {
    polo: '-',
    diretoria: '-',
    municipio: '-',
    escola: '-',
    poc: '-',
    ciclo: '-',
    dataInicio: '-',
    dataFim: '-'
  };
   public logoBase64: string | undefined;
  public formRelatorioPEC: FormGroup;
  public get form() { return this.formRelatorioPEC.controls; }



  filtrosCalendarios = signal<FiltroPadrao | undefined>(undefined);

  constructor(private cdr: ChangeDetectorRef) {
    Chart.register(...registerables);
     this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

 public barChartType: ChartType = 'bar';

  public barChartOptionsPrevencao: ChartConfiguration['options'] = {
    responsive: true,
      plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Ações de Prevenção: ${context.parsed.y}% (${this.qtyAcoesPrevencao} registros)`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100
      }
    }
  };

  public barChartOptionsAcolhimento: ChartConfiguration['options'] = {
    responsive: true,
      plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Ações de Acolhimento: ${context.parsed.y}% (${this.qtyAcoesAcolhimento} registros)`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100
      }
    }
  };



  public barChartDataPrevencao: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Prevenção',
        data: [0],
        backgroundColor: ['rgba(0, 150, 136, 0.6)'],
        borderColor: ['rgba(0, 150, 136, 0.6)'],
        borderWidth: 1,
        barThickness: 60,
        maxBarThickness: 70
      }
    ]
  };

  public barChartDataAcolhimento: ChartData<'bar'> = {
    labels: [''],
    datasets: [
      {
        label: 'Acolhimento',
        data: [0],
            backgroundColor: ['#00695c'],
        borderColor: ['#00695c'],
        borderWidth: 1,
        barThickness: 60,
        maxBarThickness: 70
      }
    ]
  };


  ngOnInit(): void {
    Chart.register(...registerables);
    // Verificar se o usuário tem o perfil 112
    if (!this.verificarAcessoPerfil112()) {
      this.toastr.warning("Você não possui acesso a este relatório!", "Acesso Negado");
      // Redirecionar para home ou página anterior
      window.history.back();
      this.listeningFiltroEmitter(this.filtros)
      return;
    }

    this.formRelatorioPEC = new FormGroup({
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null)
    });

    const DateObj = new Date();
    this.anoCalendario = DateObj.getFullYear();
    this.mesCalendario = DateObj.getMonth();
  }

  private verificarAcessoPerfil112(): boolean {
    const usuario = this.authService.getUser();

    if (!usuario) {
      return false;
    }

    return usuario.codigoPerfil === 112 || usuario.codigoPerfil === 1477;
  }

  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {

  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {

  }

  private atualizarGrafico(): void {
    this.barChartDataPrevencao.datasets[0].data = [this.porcAcoesPrevencao];
    this.barChartDataAcolhimento.datasets[0].data = [this.porcAcoesAcolhimento];
    this.charts.forEach(chart => chart.update());
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    const sequencia = ++this.pesquisaSequencia;
    this.pesquisaEmAndamento = true;
    this.spinnerService.show();

    try {
      this.setFilters(eventFilter);

      const dataInicio = eventFilter.fpDataInicio ?? null;
      const dataFim = eventFilter.fpDataFim ?? null;

      this.formRelatorioPEC.patchValue({
        dataInicio: dataInicio,
        dataFim: dataFim
      });

      await this.PesquisarChamados(sequencia);

      if (sequencia !== this.pesquisaSequencia) {
        return;
      }

      this.pesquisaRealizada = true;
      this.infoPeriodo = {
        polo: eventFilter.nomePolo || null,
        diretoria: eventFilter.nomeDiretoria || null,
        municipio: eventFilter.nomeMunicipio || null,
        escola: eventFilter.nomeEscola || null,
        poc: eventFilter.nomePOC || null,
        ciclo: eventFilter.nomeTipoEnsino || null,
        dataInicio: dataInicio || null,
        dataFim: dataFim || null
      };
    } finally {
      if (sequencia === this.pesquisaSequencia) {
        this.pesquisaEmAndamento = false;
        this.spinnerService.hide();
      }
    }
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
    this.filtrosCalendarios.set(this.filtros);
  }

  public async PesquisarChamados(sequencia?: number) {
    this.submitted = true;

    const parametros = this.SetParametrosChamados();

    if (parametros.codigoDiretoria == null || (parametros.codigoEscola == null && parametros.codigoPOC != null)) {
      this.toastr.warning("Diretoria e Escola são obrigatórios");
      return;
    }

    const response = await lastValueFrom(this.psicologoService.getRelatorioPEC(parametros)).catch((err) => {
      return this.convivaErrors.handleResultError(err);
    });

    if (sequencia !== undefined && sequencia !== this.pesquisaSequencia) {
      return;
    }

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? 'Erro ao carregar relatório');
      return;
    }

    const resumo: RelatorioPOCResumo = response.data;
    this.qtyAcoesPrevencao = resumo?.qtyPrevencao ?? 0;
    this.qtyAcoesAcolhimento = resumo?.qtyAcolhimento ?? 0;
    this.qtyAcoes = this.qtyAcoesPrevencao + this.qtyAcoesAcolhimento;

    if (this.qtyAcoes === 0) {
      this.toastr.warning("Não existem registros para essa pesquisa");
      this.porcAcoesAcolhimento = 0;
      this.porcAcoesPrevencao = 0;
      this.atualizarGrafico();
      return;
    }

    this.porcAcoesAcolhimento = Number((this.qtyAcoesAcolhimento * 100 / this.qtyAcoes).toFixed(2));
    this.porcAcoesPrevencao = Number((this.qtyAcoesPrevencao * 100 / this.qtyAcoes).toFixed(2));
    this.atualizarGrafico();
  }

  private normalizarFiltroNumerico(valor?: number | null): number | undefined {
    return valor != null && valor > 0 ? valor : undefined;
  }

  public SetParametrosChamados(): ListarChamados {
    const chamado = new ListarChamados();
    // Relatório gestor (sem filtro de polo): não enviar polo do login na consulta
    chamado.codigoDiretoria = this.normalizarFiltroNumerico(
      this.filtros?.codigoDiretoria ?? this.userLogado?.codigoDiretoria
    ) as number;
    chamado.codigoEscola = this.normalizarFiltroNumerico(this.filtros?.codigoEscola) as number;
    chamado.codigoTurno = this.normalizarFiltroNumerico(this.filtros?.codigoTurno);
    chamado.codigoTurma = this.normalizarFiltroNumerico(this.filtros?.codigoTurma);
    chamado.codigoGravidade = this.normalizarFiltroNumerico(this.filtros?.codigoGravidade);
    chamado.codigoTipoEnsino = this.normalizarFiltroNumerico(this.filtros?.codigoTipoEnsino);
    chamado.ordenacaoCrescente = false;

    const dataInicio = this.filtros?.fpDataInicio ?? this.form?.dataInicio?.value;
    const dataFim = this.filtros?.fpDataFim ?? this.form?.dataFim?.value;
    chamado.dataInicio = dataInicio === '' || dataInicio == null ? undefined : dataInicio;
    chamado.dataFim = dataFim === '' || dataFim == null ? undefined : dataFim;

    chamado.atividadeDiretoria = this.userLogado?.apenasDiretoria ?? this.filtros?.atividadeDiretoria!;
    chamado.codigoPOC = this.normalizarFiltroNumerico(this.filtros?.codigoPOC);
    return chamado;
  }

  // public SetParametrosCalendario(ano: number, mes: number): Consolidado {
  //   const parametros = new Consolidado();
  //   parametros.codigoDiretoria = this.filtros?.codigoDiretoria;
  //   parametros.codigoEscola = this.filtros?.codigoEscola;
  //   parametros.ano = ano;
  //   parametros.mes = mes;
  //   return parametros;
  // }

  public validaAno(data: AbstractControl<any, any>){
    const dataDoCampo = data.value;
    if(dataDoCampo){
     const ano = new Date(dataDoCampo).getFullYear();
      if(ano > this.DataAtual.getFullYear() || ano < this.DataAtual.getFullYear() - 10){
        data.setValue(null);
        this.toastr.warning("Data invalida! Selecione uma data valida para pesquisar.");
      }
    }
  }

  async ExportarComoPDF() {
    this.spinnerService.show();

    if (!window.jspdf) {
      console.error('Biblioteca jsPDF não encontrada');
      this.spinnerService.hide();
      return;
    }

    const { jsPDF } = window.jspdf;
    const element = this.pdfContent?.nativeElement;

    if (!element) {
      console.error('Elemento pdfContent não encontrado');
      this.spinnerService.hide();
      return;
    }

    this.cdr.detectChanges();
    this.charts?.forEach(c => c.chart?.update());
    await new Promise(r => setTimeout(r, 200));

    const canvas = await window.html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginX = 10;
    let y = 45;

    // Cabeçalho
    if (this.logoBase64) {
      pdf.addImage(this.logoBase64, 'PNG', pageWidth - 125, 12, 115, 35);
    }

    pdf.setFontSize(20)
      .setFont('helvetica', 'bold')
      .setTextColor(0, 51, 102);
    pdf.text('Relatório POC', pageWidth / 2, 30, { align: 'center' });
    pdf.setDrawColor(200);
    pdf.line(10, 38, pageWidth - 10, 38);

    // 🔍 Campos válidos
    const info = this.infoPeriodo;
    const campos = [
      { label: 'Polo', valor: info.polo },
      { label: 'URE', valor: info.diretoria },
      { label: 'Município', valor: info.municipio },
      { label: 'Escola', valor: info.escola },
      { label: 'POC', valor: info.poc },
      { label: 'Ciclo', valor: info.ciclo },
      {
        label: 'Data Início',
        valor: info.dataInicio ? new Date(info.dataInicio).toLocaleDateString('pt-BR') : '',
      },
      {
        label: 'Data Fim',
        valor: info.dataFim ? new Date(info.dataFim).toLocaleDateString('pt-BR') : '',
      },
    ].filter(c => c.valor && c.valor !== '-');

    // 🧾 Bloco “Informações do período”
    if (campos.length > 0) {
      // Quantidade de colunas automática
      const cols = campos.length >= 6 ? 3 : campos.length === 5 ? 3 : 2;
      const colWidth = (pageWidth - marginX * 2 - 10) / cols;
      const rowHeight = 11;
      const padding = 5;
      const rows = Math.ceil(campos.length / cols);
      const blocoAltura = rows * rowHeight + padding * 2;

      // Título (fora do retângulo)
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(11);
      pdf.setTextColor(30, 30, 30);
      pdf.text('Informações do período', marginX + 2, y + 5);

      y += 6;

      // Retângulo apenas nos campos
      pdf.setFillColor(255, 255, 255);
      pdf.setDrawColor(230, 230, 230);
      pdf.roundedRect(marginX, y, pageWidth - 2 * marginX, blocoAltura, 3, 3, 'FD');

      // Campos internos
      pdf.setFontSize(9);
      let linhaY = y + 7;
      let colX = marginX + 7;

      campos.forEach((c, i) => {
        const colIndex = i % cols;
        if (colIndex === 0 && i !== 0) linhaY += rowHeight;
        colX = marginX + 7 + colIndex * colWidth;

        // Label
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(100, 100, 100);
        pdf.text(c.label, colX, linhaY);

        // Valor
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(0, 0, 0);
        pdf.text(String(c.valor).toUpperCase(), colX, linhaY + 4.5);
      });

      y += blocoAltura + 12;
    }

    // Linha divisória
    pdf.setDrawColor(230);
    pdf.line(10, y - 3, pageWidth - 10, y - 3);

    // Gráficos
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pageWidth - marginX * 2;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, 'PNG', marginX, y, pdfWidth, pdfHeight);

    // Rodapé
    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(9).setTextColor(60);
      pdf.text(`Página ${i}`, pageWidth - 15, pageHeight - 8, { align: 'right' });
      pdf.text(`Usuário logado: ${this.userLogado?.nome}`, 10, pageHeight - 8, { align: 'left' });
    }

    pdf.save('relatorio-poc.pdf');
    this.spinnerService.hide();
  }


  getNomeDiretoria(codigo?: number): string {
  const item = this.filtroPadraoComponent?.diretorias?.find(d => d.codigoDiretoria === codigo);
  return item?.nomeDiretoria ?? '-';
  }

  getNomeEscola(codigo?: number): string {
    const item = this.filtroPadraoComponent?.escolas?.find(e => e.codigoEscola === codigo);
    return item?.nomeEscola ?? '-';
  }

  getNomePolo(codigo?: number): string {
    const item = this.filtroPadraoComponent?.polos?.find(p => p.codigoPolo === codigo);
    return item?.descricaoPolo ?? '-';
  }

  getNomePOC(codigo?: number): string {
    if (!codigo) return '-';
    const codigoCpf = codigo.toString(); // garante 11 dígitos se necessário
    const item = this.filtroPadraoComponent?.listaPOC?.find(p => p.cpf === codigoCpf);
    return item?.nome ?? '-';
  }

  getNomeCiclo(codigo?: number): string {
    const item = this.filtroPadraoComponent?.tipoEnsinos?.find(c => c.codigoTipoEnsino === codigo);
    return item?.nomeTipoEnsino ?? '-';
  }

}
